import AppLayout from "@/layouts/AppLayout";
import AuthLayout from "@/layouts/AuthLayout";
import RootLayout from "@/layouts/RootLayout";
import Dashboard from "@/pages/dashboard/index";
import DevLogin from "@/pages/DevLogin";
import Login from "@/pages/Login";
import Mantras from "@/pages/Mantra";
import NotFound from "@/pages/NotFound";
import RegisterCollege from "@/pages/RegisterCollege";
import Stories from "@/pages/Story";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoutes";

// People
import Staff from "@/pages/people/staff/index";
import StaffView from "@/pages/people/staff/View";

// Top-level pages
// import Alumni from "@/pages/alumni/index";
// import AlumniView from "@/pages/alumni/View";
import Batches from "@/pages/batches/index";
import BatchesView from "@/pages/batches/View";
// import CollegeProfile from "@/pages/college/profile/index";
import Department from "@/pages/department/index";
import DepartmentView from "@/pages/department/View";
import Notifications from "@/pages/notifications/index";
import Profile from "@/pages/profile/index";
import Settings from "@/pages/settings/index";
import Students from "@/pages/students/index";
import StudentsView from "@/pages/students/View";
import Tickets from "@/pages/tickets/index";
import TicketsView from "@/pages/tickets/View";

// Vendors
import InternVendors from "@/pages/vendors/intern/index";
import InternVendorsView from "@/pages/vendors/intern/View";
import PlacementVendors from "@/pages/vendors/placement/index";
import PlacementVendorsView from "@/pages/vendors/placement/View";
import SoftSkillVendors from "@/pages/vendors/soft-skill/index";
import SoftSkillVendorsView from "@/pages/vendors/soft-skill/View";
import TechSkillVendors from "@/pages/vendors/tech-skill/index";
import TechSkillVendorsView from "@/pages/vendors/tech-skill/View";

// Activities
// import Internships from "@/pages/activities/internships/index";
// import InternshipsView from "@/pages/activities/internships/View";
// import ActivityPlacement from "@/pages/activities/placement/index";
// import ActivityPlacementView from "@/pages/activities/placement/View";
// import SoftSkills from "@/pages/activities/soft-skills/index";
// import SoftSkillsView from "@/pages/activities/soft-skills/View";
// import TechSkills from "@/pages/activities/tech-skills/index";
// import TechSkillsView from "@/pages/activities/tech-skills/View";
import Skills from "@/pages/profile/Skills";
import Resumes from "@/pages/profile/Resumes";
import Education from "@/pages/profile/Education";
import Documents from "@/pages/profile/Documents";

import DiscoverInternships from "@/pages/discover/Internships/index";
import DiscoverInternshipView from "@/pages/discover/Internships/View";
import DiscoverCompanies from "@/pages/discover/Companies/index";
import DiscoverCompanyProfile from "@/pages/discover/Companies/View";
import ApplicationsPage from "@/pages/applications/index";
import BookmarksPage from "@/pages/bookmarks/index";
import InterviewsPage from "@/pages/interviews/index";
import InterviewView from "@/pages/interviews/View";
import OffersPage from "@/pages/offers/index";
import WorkLogsPage from "@/pages/work-logs/index";

const routes = [
  {
    element: <RootLayout />, // for providing common auth provider since we use useNavigate in auth provider using navigate before route initialization throws error
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: "login",
            element: <Login />,
          },
          {
            path: "register-college",
            element: <RegisterCollege />,
          },
        ],
      },
      // Protected routes (AppLayout)
      {
        element: <ProtectedRoute />, // <- wrap AppLayout
        children: [
          {
            path: "/",
            element: <AppLayout />,
            children: [
              {
                element: <Dashboard />,
                index: true,
              },
              {
                path: "dashboard",
                element: <Navigate to="/" replace />,
              },
              // Legacy feature pages
              { path: "mantras", element: <Mantras /> },
              { path: "stories", element: <Stories /> },
              // People
              { path: "people/staff", element: <Staff /> },
              { path: "people/staff/:id", element: <StaffView /> },
              // Top-level
              // { path: "college/profile", element: <CollegeProfile /> },
              { path: "department", element: <Department /> },
              { path: "department/:id", element: <DepartmentView /> },
              { path: "batches", element: <Batches /> },
              { path: "batches/:id", element: <BatchesView /> },
              { path: "students", element: <Students /> },
              { path: "students/:id", element: <StudentsView /> },
              // { path: "alumni", element: <Alumni /> },
              // { path: "alumni/:id", element: <AlumniView /> },
              { path: "tickets", element: <Tickets /> },
              { path: "tickets/:id", element: <TicketsView /> },
              { path: "notifications", element: <Notifications /> },
              { path: "settings", element: <Settings /> },
              { path: "profile", element: <Profile /> },
              // Vendors
              { path: "vendors/intern", element: <InternVendors /> },
              { path: "vendors/intern/:id", element: <InternVendorsView /> },
              { path: "vendors/placement", element: <PlacementVendors /> },
              {
                path: "vendors/placement/:id",
                element: <PlacementVendorsView />,
              },
              { path: "vendors/soft-skill", element: <SoftSkillVendors /> },
              {
                path: "vendors/soft-skill/:id",
                element: <SoftSkillVendorsView />,
              },
              { path: "vendors/tech-skill", element: <TechSkillVendors /> },
              {
                path: "vendors/tech-skill/:id",
                element: <TechSkillVendorsView />,
              },
              // Activities
              // { path: "activities/internships", element: <Internships /> },
              // {
              //   path: "activities/internships/:id",
              //   element: <InternshipsView />,
              // },
              // { path: "activities/placement", element: <ActivityPlacement /> },
              // {
              //   path: "activities/placement/:id",
              //   element: <ActivityPlacementView />,
              // },
              // { path: "activities/soft-skills", element: <SoftSkills /> },
              // {
              //   path: "activities/soft-skills/:id",
              //   element: <SoftSkillsView />,
              // },
              // { path: "activities/tech-skills", element: <TechSkills /> },
              // {
              //   path: "activities/tech-skills/:id",
              //   element: <TechSkillsView />,
              // },
              { path: "profile/skills", element: <Skills /> },
              { path: "profile/resumes", element: <Resumes /> },
              { path: "profile/education", element: <Education /> },
              { path: "profile/documents", element: <Documents /> },
              // Discovery Hub
              { path: "discover/internships", element: <DiscoverInternships /> },
              { path: "discover/internships/:id", element: <DiscoverInternshipView /> },
              { path: "discover/companies", element: <DiscoverCompanies /> },
              { path: "discover/companies/:id", element: <DiscoverCompanyProfile /> },
              // Applications
              { path: "applications", element: <ApplicationsPage /> },
              // Interviews (read-only — the recruiter owns scheduling)
              { path: "interviews", element: <InterviewsPage /> },
              { path: "interviews/:id", element: <InterviewView /> },
              // Offers
              { path: "offers", element: <OffersPage /> },
              // Work Logs
              { path: "work-logs", element: <WorkLogsPage /> },
              // Bookmarks
              { path: "bookmarks", element: <BookmarksPage /> },
            ],
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

// **conditionally add dev route**
if (import.meta.env.VITE_MODE === "development") {
  routes?.[0]?.children.push({
    path: "dev-login",
    element: <DevLogin />,
  });
}

export const router = createBrowserRouter(routes);

export default router;
